var App = App || {};
var currentBP = ZAGFramework.GetCurrentBP();

App.MastheadPromos = (function ($) {
    "use strict";

    function init() {
        var $mastheadPromos = $(".block-masthead-promos"),
            $splide = $mastheadPromos.find(".splide");

        if ($splide.length) {
            var splide = new Splide(".block-masthead-promos .splide", {
                focus: 0,
                pagination: false,
                perMove: 1,
                perPage: 2,
                type: "loop"
            });

            var components = splide.Components;

            splide.on("overflow", function (isOverflow) {
                splide.options = {
                    arrows: isOverflow,
                    drag: isOverflow
                }
            });

            splide.on("resized", function () {
                var isOverflow = components.Layout.isOverflow();
                var list = components.Elements.list;
                var lastSlide = components.Slides.getAt(splide.length - 1);

                if (lastSlide) {
                    list.style.justifyContent = isOverflow ? "" : "center";

                    if (!isOverflow) {
                        lastSlide.slide.style.marginRight = "";
                    }
                }
            });

            splide.mount();
        }
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.MastheadPromos.init();
});